import { useEffect, FC, useState } from "react";
import { Tabs, Text } from "@mantine/core";
import { useStyles } from "./SkuLoanApplication.styles";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import LTVAcceptanceSKU from "../LTVacceptance/LTVAcceptanceSKU";
import SFpayment from "../SFpayment/SFpayment";
import LTVAcceptanceSKUConfirm from "../LTVacceptance-Confirmed/LTVAcceptanceSKUConfirm";
import SkuLoanApplicationSubmitted from "./Tabs/Submitted";
import Review from "./Tabs/Review";
import New from "./Tabs/New";

const SkuLoanApplication: FC = () => {
  const { classes } = useStyles();
  const { tabValue } = useParams();
  const [activeTab, setActiveTab] = useState(tabValue || "new");
  const [rerender, setRerender] = useState(true);
  const isAdminAuthRep = useSelector(
    (state: RootState) => state.auth.isAdminAuthRep
  );

  const navigate = useNavigate();

  const handleTabChange = (value: string) => {
    setActiveTab(value);
  };

  const handleTabChangeReload = (value: string) => {
    navigate(`/collaboration-proposal/${value}`);
    window.location.reload();
  };

  useEffect(() => {
    navigate(`/collaboration-proposal/${activeTab}`);
  }, [activeTab]);

  return (
    <div className={classes.loanApplicationContainer}>
      <Text className={classes.heading}>Collaboration Proposal</Text>
      {rerender && (
        <Tabs defaultValue={tabValue || "new"} onTabChange={handleTabChange}>
          <Tabs.List>
            {/* <Tabs.Tab value="new">New</Tabs.Tab>
            <Tabs.Tab value="review">Review</Tabs.Tab> */}
            <Tabs.Tab value="submission">Submission</Tabs.Tab>
            <Tabs.Tab value="indicative-offer">Indicative Offer</Tabs.Tab>
            {/* <Tabs.Tab value="loan-payment"> Deposit</Tabs.Tab> */}
            {isAdminAuthRep && <Tabs.Tab value="agreement-1">Agreement</Tabs.Tab>}
          </Tabs.List>
          <br />

          {/* {activeTab === "new" && (
            <Tabs.Panel value="new">
              <New onEvent={handleTabChangeReload} />
            </Tabs.Panel>
          )}

          {activeTab === "review" && (
            <Tabs.Panel value="review">
              <Review />
            </Tabs.Panel>
          )} */}

          {activeTab === "submission" && (
            <Tabs.Panel value="submission">
              <SkuLoanApplicationSubmitted />
            </Tabs.Panel>
          )}

          {activeTab === "indicative-offer" && (
            <Tabs.Panel value="indicative-offer">
              <LTVAcceptanceSKU onEvent={handleTabChangeReload} />
            </Tabs.Panel>
          )}
          {/* 
          {activeTab === "loan-payment" && (
            <Tabs.Panel value="loan-payment">
              <SFpayment />
            </Tabs.Panel>
          )} */}

          {isAdminAuthRep && activeTab === "agreement-1" && (
            <Tabs.Panel value="agreement-1">
              <LTVAcceptanceSKUConfirm onEvent={handleTabChangeReload} />
            </Tabs.Panel>
          )}
        </Tabs>
      )}
    </div>
  );
};

export default SkuLoanApplication;
